import { ConsentGate } from "@/components/ConsentFields";
import { Outlet, Link } from "react-router-dom";
import { Header } from "@/components/Header";

const LEGAL_LINKS = [
  { label: "Chi siamo", href: "https://www.deltapictures.it/", external: true },
  { label: "Contatti", href: "/contatti", external: false },
  { label: "Disclaimer", href: "https://www.deltapictures.it/disclaimer/", external: true },
  { label: "Privacy Policy", href: "https://www.deltapictures.it/privacy-policy/", external: true },
  { label: "Cookie Policy", href: "https://www.deltapictures.it/cookie-policy/", external: true },
];

const LEGAL_LINK_CLASS = "text-[11px] text-subtle hover:text-brand transition-colors";

function openConsentUi() {
  if (typeof window.__tcfapi === "function") {
    window.__tcfapi("displayConsentUi", 2, function () {});
    return;
  }
  // CMP non ancora caricata: riprova a breve, poi rinuncia dopo 5s
  const t = setInterval(function () {
    if (typeof window.__tcfapi === "function") {
      clearInterval(t);
      window.__tcfapi("displayConsentUi", 2, function () {});
    }
  }, 300);
  setTimeout(function () { clearInterval(t); }, 5000);
}

function Footer() {
  return (
    <footer className="border-t border-hair mt-10 bg-surfaceSecondary">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2.5 sm:gap-6">
        <div className="flex flex-col leading-none items-center sm:items-start">
          <div className="flex items-baseline gap-0.5">
            <span className="font-display text-lg font-bold text-onSurface">Readoo</span>
            <span className="w-1 h-1 rounded-full bg-brand mb-1" />
            <span data-testid="footer-beta-badge" className="font-mono text-[9px] font-semibold uppercase tracking-wider text-brand ml-0.5">Beta</span>
          </div>
          <p className="text-[10px] font-medium text-subtle leading-tight mt-0.5">
            L'informazione che ti premia
          </p>
        </div>

        {/* Riga link legali + gestione consensi CMP */}
        <nav
          data-testid="footer-legal-links"
          className="flex flex-wrap items-center justify-center sm:justify-end gap-x-3 gap-y-1 border-t border-hair pt-2.5 sm:border-0 sm:pt-0"
          aria-label="Link legali"
        >
          <Link to="/vantaggi" data-testid="footer-vantaggi" className="text-[11px] font-semibold text-brand hover:underline">Vantaggi</Link>
          {LEGAL_LINKS.map((l) =>
            l.external ? (
              <a
                key={l.label}
                href={l.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-legal-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={LEGAL_LINK_CLASS}
              >
                {l.label}
              </a>
            ) : (
              <Link
                key={l.label}
                to={l.href}
                data-testid={`footer-legal-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={LEGAL_LINK_CLASS}
              >
                {l.label}
              </Link>
            )
          )}
          <button
            id="manage-consent"
            type="button"
            onClick={openConsentUi}
            data-testid="footer-manage-consent"
            className={LEGAL_LINK_CLASS}
          >
            Gestione consensi
          </button>
        </nav>
        </div>

        <p data-testid="footer-company-details" className="text-[10px] sm:text-[11px] text-subtle mt-2.5 pt-2.5 sm:mt-3 sm:pt-3 border-t border-hair sm:font-mono text-center leading-snug">
          © {new Date().getFullYear()} Readoo · Powered by{" "}
          <a href="https://www.deltapictures.it/" target="_blank" rel="noopener noreferrer" className="text-brand hover:underline">
            Delta Pictures S.r.l.
          </a>{" "}
          - Via G. Boglietti 2, 13900 Biella · <a href="mailto:info@deltapictures.it" className="hover:text-brand transition-colors">info@deltapictures.it</a> · Cap. Soc. € 50.000 i.v. · P. IVA: 02154000026 · n. R.E.A. BI 181760
        </p>
      </div>
    </footer>
  );
}

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-surface">
      <Header />
      <ConsentGate />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
